// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePptTwoToneSvg from "@ant-design/icons-svg/es/asn/FilePptTwoTone";
import AntdIcon from '../components/AntdIcon';

var FilePptTwoTone = function FilePptTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePptTwoToneSvg
  }));
};

FilePptTwoTone.displayName = 'FilePptTwoTone';
export default React.forwardRef(FilePptTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FilePptTwoTone.js
// module id = 1135
// module chunks = 0